module.exports = __webpack_public_path__ + "static/media/adrian26.6ae28ff8.JPG";